import GUI from "lil-gui";

export default class Debug {
    constructor() {
        this.active =
            window.location.hash === "#debug" ||
            window.location.hostname === "localhost";

        if (this.active) {
            this.ui = new GUI();
        }
    }
}
